<template>
  <Teleport
    :to="teleportTo"
    :disabled="!teleportEnabled">
    <SlideTransition v-show="isVisible">
      <div
        :id="id"
        v-bind="$attrs"
        class="sticky-footer p-sm mx-xxs">
        <slot name="content"/>
      </div>
    </SlideTransition>
  </Teleport>
</template>

<script setup>
import { computed, watch } from 'vue'
import SlideTransition from '@shared/components/ADORN/transitions/SlideTransition.vue'

defineOptions({
  inheritAttrs: false
})

const props = defineProps({
  isVisible: {
    type: Boolean,
    default: true
  },
  teleportTo: {
    type: [String, HTMLElement],
    default: () => null
  },
  id: {
    type: String,
    default: null
  }
})

const emits = defineEmits(['show', 'hide'])

const teleportEnabled = computed(() => props.teleportTo !== null)

watch(() => props.isVisible, (newVal) => {
  if (newVal) emits('show')
  else emits('hide')
})
</script>

<style lang="scss" scoped>
.sticky-footer {
  position: fixed;
  bottom: 0;
  width: calc(100vw - (#{$spacing-xxs} * 2));
  // inline-flex is used to keep Safari UI from hiding the footer
  display: inline-flex;
  justify-content: center;
  background-color: white;
  border: solid 1px $ash;
  border-bottom: none;
  border-radius: 4px 4px 0px 0px;
  box-shadow: 0px 1px 8px 0px rgba(23, 23, 35, 0.10);
  z-index: $zindex-sticky;
}
</style>

<style lang="scss">
// Offset for vertical nav
@include media-desktop {
  body:has(nav.navigation:not(.prospect)) .sticky-footer {
    width: calc(100vw - (#{$spacing-xxs} * 2) - $desktop-nav-width);
    left: $desktop-nav-width;
  }
}
</style>
